'use strict';
// const ProcessDefinitionsResource = require('flowable-js-api/lib/resources/process-definitions');
// const ProcessInstancesResource = require('flowable-js-api/lib/resources/process-instances');
// const TasksResource = require('flowable-js-api/lib/resources/tasks');
// const TaskVariablesResource = require('flowable-js-api/lib/resources/task-variables');
// const axios = require('axios');

const flowableRestEndpoint = '/service';


module.exports = function (options) {

    // const httpClient = axios.create({
    //     baseURL: options.apiUri + flowableRestEndpoint,
    //     timeout: options.timeout || 0,
    //     headers: {
    //       'content-type': 'application/json',
    //       'Authorization': `Basic ${btoa(`${options.auth.username}:${options.auth.password}`)}`
    //     },
    //     withCredentials: false,
    //     //auth: options.auth
    // });

    return {
        // processDefinitions: new ProcessDefinitionsResource(options, httpClient),
        // processInstances: new ProcessInstancesResource(options, httpClient),
        // //processInstanceVariables: new ProcessInstanceVariablesResource(options, httpClient),
        // tasks: new TasksResource(options, httpClient),
        // taskVariables: new TaskVariablesResource(options, httpClient),
        options: options
    }
};